module.exports = __webpack_public_path__ + "img/nathalie_cabinet_saint-cyr-lecole-mobile.0dcb25b5.webp";